// src/utils/format/initials.js
//
// THE initials rule for every avatar in the app (one source of truth).
// - trims + collapses spaces; an email uses its local part, split on
//   non-alphanumerics ("marco.diaz@x.com" -> "MD")
// - LETTERS only: a word with no letter ("01", "#2") is skipped, so "Test Customer 01" -> "TC"
//   (when there is no letter anywhere, the digits are used so a name is never blank)
// - 2+ words -> first letter of the first and last word
// - 1 word   -> its first two letters
// - uppercased with toLocaleUpperCase, accents preserved ("Ángel" -> "ÁN")
// - '?' when there is nothing to show

const firstChar = (word) => Array.from(word)[0] || '';

export function getInitials(name) {
  const raw = String(name || '').trim();
  if (!raw) return '?';
  const base = raw.includes('@') ? raw.split('@')[0].replace(/[^\p{L}\p{N}]+/gu, ' ') : raw;
  const all = base.trim().split(/\s+/).filter(Boolean);
  if (!all.length) return '?';
  const lettered = all.filter((w) => /\p{L}/u.test(w));
  const words = (lettered.length ? lettered : all).map((w) => (lettered.length ? w.replace(/^[^\p{L}]+/u, '') : w));
  const out = words.length === 1
    ? Array.from(words[0]).filter((c) => !lettered.length || /\p{L}/u.test(c)).slice(0, 2).join('')
    : firstChar(words[0]) + firstChar(words[words.length - 1]);
  return out.toLocaleUpperCase();
}
